export const dropdownstatus = [
    {
        label: 'Tất cả',
        value: null,
    },
    {
        label: 'Đang sử dụng',
        value: true,
    },
    {
        label: 'Ngưng sử dụng',
        value: false,
    },
];
